var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket_item_show"},[(_vm.item_value)?_c('van-row',[_c('van-col',{attrs:{"span":6}},[_vm._v(_vm._s(_vm.item_name)+":")]),_c('van-col',{attrs:{"span":18}},[_vm._v(_vm._s(_vm.item_value))])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }